import { dcopy } from '~/utils/utils'
import { deepFreeze } from '~/utils/v'
import {
  SEARCH_BOOLEAN_ATTRIBUTE,
  SEARCH_INTEGER_ATTRIBUTE, SEARCH_LIST_ATTRIBUTE, SEARCH_MINMAX_ATTRIBUTE,
  SEARCH_STRING_ATTRIBUTE
} from '~/utils/search/search-attribute.class'

export const SEARCH_PAGES = ['search', 'search_with_boat', 'search_with_boat_charter']
export const SEARCH_OTHER_PAGES = ['index', 'brand', 'destination', 'destination-location', 'boat-type', 'boat-view', 'sailing-holidays', 'sailing-with-skipper', 'digital-flotilla']
export const SEARCH_OTHER_PAGES_FILTERS_WHITELIST = ['charter_types', 'boat_types']
export const SEARCH_BOAT_ANY_TYPE_ID = 9999
export const SEARCH_BOAT_ANY_TYPE = 'any'

export const DEFAULT_SEARCH_RANGES_WITHOUT_OPTIONS = dcopy({
  min: null,
  max: null
})
export const getDefaultValueForType = (type, value = undefined) => {
  switch (type) {
    case SEARCH_BOOLEAN_ATTRIBUTE:
      return null
    case SEARCH_INTEGER_ATTRIBUTE:
      return null
    case SEARCH_LIST_ATTRIBUTE:
      return []
    case SEARCH_MINMAX_ATTRIBUTE:
      return dcopy(DEFAULT_SEARCH_RANGES_WITHOUT_OPTIONS)
    case SEARCH_STRING_ATTRIBUTE:
      return null
    default:
      console.warn(`Attribute type ${type} not found`)
  }
}
export const SEARCH_PARAMS_TYPE = {
  lang: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: null
  },
  location: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  boatType: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  charterType: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  page: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    initial: 1
  }
}
export const SEARCH_QUERY_TYPE = deepFreeze({
  duration: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_INTEGER_ATTRIBUTE)
  },
  start_date: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  boat_types: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_INTEGER_ATTRIBUTE,
    routerKey: 'boat_type_id',
    requestKey: 'boat_type_id',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  prices: {
    type: 'minmaxRanges',
    start: {
      type: SEARCH_MINMAX_ATTRIBUTE,
      range: {
        min: 0,
        max: 0
      }
    },
    end: {
      type: SEARCH_MINMAX_ATTRIBUTE,
      range: {
        min: 0,
        max: 0
      }
    },
    initial: []
  },
  price_start: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_INTEGER_ATTRIBUTE)
  },
  price_end: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_INTEGER_ATTRIBUTE)
  },
  internal_banner: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  cabins: {
    type: SEARCH_MINMAX_ATTRIBUTE,
    range: {
      min: 0,
      max: 0
    },
    initial: getDefaultValueForType(SEARCH_MINMAX_ATTRIBUTE)
  },
  bathrooms: {
    routerKey: 'bathrooms',
    requestKey: 'bathrooms',
    responseKey: 'toilets',

    type: SEARCH_MINMAX_ATTRIBUTE,
    range: {
      min: 0,
      max: 0
    },
    initial: getDefaultValueForType(SEARCH_MINMAX_ATTRIBUTE)
  },
  lengths: {
    type: SEARCH_MINMAX_ATTRIBUTE,
    routerKey: 'length',
    requestKey: 'length',
    range: {
      min: 0,
      max: 0
    },
    initial: getDefaultValueForType(SEARCH_MINMAX_ATTRIBUTE)
  },
  years: {
    type: SEARCH_MINMAX_ATTRIBUTE,
    routerKey: 'year',
    requestKey: 'year',
    range: {
      min: 0,
      max: 0
    },
    initial: getDefaultValueForType(SEARCH_MINMAX_ATTRIBUTE)
  },
  companies: {
    type: SEARCH_LIST_ATTRIBUTE,
    routerKey: 'companies',
    requestKey: 'company_id',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  brands: {
    type: SEARCH_LIST_ATTRIBUTE,
    routerKey: 'brand',
    requestKey: 'brand',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  locations: {
    type: SEARCH_LIST_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  subLocations: {
    type: SEARCH_LIST_ATTRIBUTE,
    routerKey: 'subLocations',
    requestKey: 'subLocations',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  booking_systems: {
    type: SEARCH_LIST_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  charter_types: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    requestKey: 'charter_type_id',
    routerKey: 'charter_type_id',
    initial: getDefaultValueForType(SEARCH_INTEGER_ATTRIBUTE)
  },
  sail_type: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  genoa_type: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  models: {
    type: SEARCH_LIST_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  marinas: {
    type: SEARCH_LIST_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  equipments: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_INTEGER_ATTRIBUTE,
    responseKey: 'equipments',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  guestRange: {
    routerKey: 'guestRange',
    responseKey: 'guests',
    type: SEARCH_MINMAX_ATTRIBUTE,
    range: {
      min: 0,
      max: 0
    },
    initial: getDefaultValueForType(SEARCH_MINMAX_ATTRIBUTE)
  },
  licenseRequired: {
    type: SEARCH_BOOLEAN_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_BOOLEAN_ATTRIBUTE)
  },
  limitDeal: {
    type: SEARCH_BOOLEAN_ATTRIBUTE,
    initial: false
  },
  sortBy: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: '-premium_boat'
  },
  // page: {
  //   type: SEARCH_INTEGER_ATTRIBUTE,
  //   initial: 1
  // },
  proposal: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  requestId: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  flexibility: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  showNonAvailable: {
    type: SEARCH_BOOLEAN_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_BOOLEAN_ATTRIBUTE)
  },
  currency: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: 'GBP'
  },
  user: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE)
  },
  filters: {
    type: SEARCH_BOOLEAN_ATTRIBUTE,
    initial: false
  },
  search_type: {
    type: SEARCH_STRING_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_STRING_ATTRIBUTE),
    showInQuery: false
  },
  booking_options: {
    type: SEARCH_INTEGER_ATTRIBUTE,
    routerKey: 'booking_option_id',
    requestKey: 'booking_option_id',
    initial: getDefaultValueForType(SEARCH_INTEGER_ATTRIBUTE)
  },
  extras: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_STRING_ATTRIBUTE,
    routerKey: 'extra',
    requestKey: 'extra',
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  company_status: {
    type: SEARCH_LIST_ATTRIBUTE,
    listOf: SEARCH_INTEGER_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_LIST_ATTRIBUTE)
  },
  limit_date: {
    type: SEARCH_BOOLEAN_ATTRIBUTE,
    initial: getDefaultValueForType(SEARCH_BOOLEAN_ATTRIBUTE),
    showInQuery: false
  }
})
export const INITIAL_SEARCH_TERMS = () => {
  const result = {}
  for (const [key, value] of Object.entries(SEARCH_QUERY_TYPE)) {
    result[key] = value.initial
  }
  for (const [key, value] of Object.entries(SEARCH_PARAMS_TYPE)) {
    result[key] = value.initial
  }
  return result
}
export const SEARCH_KEYS_WHITELIST_API = generateWhitelist({ ...SEARCH_QUERY_TYPE, ...SEARCH_PARAMS_TYPE }, 'requestKey')
export const SEARCH_KEYS_WHITELIST_ROUTER_PARAMS = generateWhitelist(SEARCH_PARAMS_TYPE, 'routerKey')
export const SEARCH_KEYS_WHITELIST_ROUTER_QUERY = generateWhitelist(SEARCH_QUERY_TYPE, 'routerKey')
export const SEARCH_REG_WHITELIST_ROUTER_QUERY = [/utm.+/]
export const SEARCH_RESETTABLE_ATTRIBUTES = [...generateWhitelist({ ...SEARCH_QUERY_TYPE, ...SEARCH_PARAMS_TYPE }, null), ...['page']]
  .filter(key => !['lang', 'location', 'locations', 'start_date', 'duration', 'companies'].includes(key))
export const SEARCH_SOMETIMES_RESETTABLE_ATTRIBUTE = [
  ...Object.keys(SEARCH_QUERY_TYPE).filter(i => ['start_date', 'duration', 'locations'].includes(i)),
  ...Object.keys(SEARCH_PARAMS_TYPE).filter(i => ['boatType', 'charterType', 'companies'].includes(i))
]
export const SEARCH_SYNCED_ATTRIBUTES_MAP = generateSyncedParamsMap([
  ['charterType', 'charter_types'],
  ['boatType', 'boat_types']
])

function generateWhitelist (object, keyType) {
  return Object.entries(object).map(([key, value]) => {
    return value[keyType] || key
  })
}

function generateSyncedParamsMap (pairs) {
  const map = new Map()
  pairs.forEach(([paramA, paramB]) => {
    map.set(paramA, paramB)
    map.set(paramB, paramA)
  })
  return map
}

export function getSyncedParams (key) {
  const result = new Set([key])

  for (const [paramA, paramB] of SEARCH_SYNCED_ATTRIBUTES_MAP) {
    if (result.has(paramA)) {
      result.add(paramB)
    } else if (result.has(paramB)) {
      result.add(paramA)
    }
  }

  return Array.from(result)
}
